// Right after sign-in: the start page the organization chose for the user's role, when the user
// can open it; Home otherwise. Clicking Home in the menu is not affected.
import type { Permission } from '@twinlink/shared';
import { Navigate, useParams } from 'react-router-dom';
import { FullPageLoader } from '@web/app/shell/StatePages';
import { useOrgContext } from '@web/lib/org';
import { NAV_ITEMS } from './navigation';

export function StartRedirect() {
  const { orgId = '' } = useParams();
  const org = useOrgContext(orgId);
  if (org.isPending) return <FullPageLoader />;
  const role = org.data?.role;
  const wanted = role ? org.data?.settings.startPages?.[role] : undefined;
  const item = NAV_ITEMS.find((n) => n.scope === 'org' && n.key === wanted);
  const perms = new Set((org.data?.permissions ?? []) as Permission[]);
  const allowed = !!item && (item.anyOf.length === 0 || item.anyOf.some((p) => perms.has(p))) && !(item.hideForClient && role === 'client');
  return <Navigate to={allowed && item.path ? `/o/${orgId}/${item.path}` : `/o/${orgId}`} replace />;
}
